import styled from 'styled-components';

import { getThemeProps } from 'ravenjs/utils/theme';

import { DEFAULT_COLORS } from 'constants/colors';

const AccountSwitcherHeaderStyled = styled.header`
    width: 100%;
    background-color: ${DEFAULT_COLORS.WHITE};
    border-bottom: 1px solid ${DEFAULT_COLORS.GREY_21};
    z-index: 10;
    ${getThemeProps('AccountSwitcherHeader.styles')};
`;

export const AccountSwitcherHeaderInner = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    /* Desktop: min-width 1200px */
    min-height: ${({ theme }) => {
        const height = getThemeProps('AccountSwitcherHeader.height', 46, { theme });
        return `${height}px`;
    }};
    padding: 8px 82px;

    /* Tablet Landscape: 992px to 1199px */
    @media (min-width: 992px) and (max-width: 1199px) {
        padding: 8px 48px;
    }

    /* Tablet Portrait: max-width 991px */
    @media (max-width: 991px) {
        padding: 8px 48px;
    }

    /* Mobile: max-width 675px */
    @media (max-width: 675px) {
        min-height: 58px;
        padding: 8px 15px;
        align-items: flex-start;
    }
`;

export default AccountSwitcherHeaderStyled;
